import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-create-brand-hub',
  templateUrl: './create-brand-hub.component.html',
  styleUrls: ['./create-brand-hub.component.scss']
})
export class CreateBrandHubComponent implements OnInit {
  brandHubdetails: any
  createOrEdit: any
  brandHubForm: any;
  brandhubTypes: any
  modalBrandType: any = ''
  submitted: boolean = false

  image: any = ''
  showImage: boolean = false
  types: any;
  thumbnail: any = '';
  imagename = "Select the Image"
  thubnailname = "Select the Thumbnail"
  isSilde: boolean = false
  VideoType: any = ''
  Filename: any = ''
  videoFile: any = 1
  currentDate: any

  @Output() brandHubCreated: EventEmitter<boolean> = new EventEmitter
  @Output() brandHubCreatedID: EventEmitter<any> = new EventEmitter

  public editorConfig = {
    height: 300,
    toolbar: [
      ['Format', 'Font', 'FontSize'], ['Bold', 'Italic'], ['NumberedList', 'BulletedList'], ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
      ['Undo', 'Redo'], ['Maximize', 'Image'],
    ],
    extraPlugins: 'uploadimage',
    uploadUrl: this.apiConfig.uploadImages,
    filebrowserUploadMethod: 'form',
    filebrowserImageBrowseUrl: 'src/assets/imageViewer/',

    filebrowserImageUploadUrl: this.apiConfig.uploadImages,
    hidden: false
  }

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
  ) {

    this.brandHubdetails = JSON.parse(localStorage.getItem("brandhubdeatails"))
    this.createOrEdit = this.brandHubdetails.ModalName


    this.currentDate = new Date().toISOString().split('T')[0]
  }

  ngOnInit() {
    console.log(this.brandHubdetails)
    this.FormGroup()
    this.getBrandhubTypes()
    if (this.brandHubdetails.ModalName == "edit") {
      console.log('patch value on edit and fisrt call the api')
      this.getBrandhubonId()
    }
  }

  getBrandhubTypes() {
    this.apiService.get(this.apiConfig.getBrandhubTypes).subscribe((res: any) => {
      console.log(res)
      this.brandhubTypes = res.data;
    })
  }

  getBrandhubonId() {
    this.apiService.get(this.apiConfig.getBrandhub + `?brand_hub_id=${this.brandHubdetails.brandHubid}`).subscribe((res: any) => {
      this.patchvalue(res.data[0])
    })
  }

  FormGroup() {
    this.brandHubForm = this.fb.group({
      brand_hub: ['', Validators.compose([Validators.required])],
      start_date: ['', Validators.compose([Validators.required,])],
      end_date: ['', Validators.compose([Validators.required,])],
      discription: ['', Validators.compose([])],
      title: ['', Validators.compose([Validators.required,])],
      image: ['', Validators.required],
      thumbnail: [''],
      image_url: ['', Validators.required],
    })
  }

  patchvalue(response) {
    this.brandHubForm.patchValue({
      brand_hub: response.brand_hub_type,
      start_date: moment(response.start_date).format("YYYY-MM-DD"),
      end_date: moment(response.end_date).format("YYYY-MM-DD"),
      discription: response.description,
      title: response.title,
      image: '',
      thumbnail: '',
      image_url: response.external_url
    })

    this.brandHubForm.controls["image"].clearValidators();
    this.brandHubForm.controls["thumbnail"].clearValidators();
    this.brandHubForm.controls["image"].updateValueAndValidity();
    this.brandHubForm.controls["thumbnail"].updateValueAndValidity();

    this.imagename = ''
    this.thubnailname = ''
    this.showImage = true
    this.image = response.image_video_url
    this.thumbnail = response.thumbnail
  }

  get f() {
    return this.brandHubForm.controls
  }

  brandHubTypeChanged() {
    if (this.modalBrandType == 3) {
      this.brandHubForm.controls["thumbnail"].setValidators(Validators.required)
      this.brandHubForm.controls["thumbnail"].updateValueAndValidity()
    } else {
      this.brandHubForm.controls["thumbnail"].clearValidators()
      this.brandHubForm.controls["thumbnail"].updateValueAndValidity()
    }
  }

  isSlideChange() {
    console.log(this.isSilde)
    this.isSilde = !this.isSilde
    console.log(this.isSilde)
  }

  onSubmit(fomrData) {

    this.submitted = true
    if (this.brandHubForm.invalid) {
      console.log('formInvalid', this.brandHubForm)
      return
    }
    let payload = {
      "brand_hub_type": fomrData.brand_hub,
      "image_video_url": this.image,
      "title": fomrData.title,
      "description": fomrData.discription,
      "start_date": moment(fomrData.start_date).format("YYYY-MM-DD"),
      "end_date": moment(fomrData.end_date).format("YYYY-MM-DD"),
      "external_url": fomrData.image_url,
      'thumbnail': this.thumbnail,
      'is_slide': this.isSilde == true ? 1 : 0
    }

    if (this.createOrEdit == 'create') {
      console.log(payload)
      this.apiService.post(this.apiConfig.createBrandhub, payload).subscribe((res: any) => {
        console.log(res);
        this.toast.Success(res.body.data.message)
        this.brandHubCreated.emit(true)
        this.brandHubCreatedID.emit(res.body.data.id)
      }), err => {
        console.log(err)

      }
    }
    else if (this.createOrEdit == 'edit') {
      payload["brand_hub_id"] = this.brandHubdetails.brandHubid
      console.log(payload)
      this.apiService.post(this.apiConfig.updateBrandhub, payload).subscribe((res: any) => {
        console.log(res);
        this.toast.Success(res.body.data.message)
        this.brandHubCreated.emit(true)
        this.brandHubCreatedID.emit(this.brandHubdetails.brandHubid)
      })
    }
  }




  uploadFiles(e, type?) {
    this.showImage = true
    console.log(e)
    type ? this.types = type : this.types = ''

    let fileList: FileList = e.target.files;
    const file: File = fileList[0];
    this.handleInputChange(file)
    type == 'blog' ? this.thubnailname = fileList[0].name : this.imagename = fileList[0].name
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.types == 'blog' ? this.thumbnail = 'data:image/png;base64,' + base64result : this.image = 'data:image/png;base64,' + base64result
  }

  empty_image_url_fomrcontrol() {
    // this function is writtin to empty the fomr control of image url because throwing error as the same control is binding to diffent controls
    this.brandHubForm.controls['image_url'].patchValue('')

  }

  selectVideoTypes(e) {
    this.Filename = e.target.files[0].name
    this.videoFile = e.target.files[0]
  }
}
